<template>
  <div id="root">
    <h1>Click on a meditation to pray!</h1>
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="card demo-icons">
            <div class="card-body all-icons">
              <div id="icons-wrapper">
                <section>
                  <ul>
                    <li
                      v-for="(meditation, index) in meditations"
                      :key="meditation.id"
                      @click="show(index)"
                    >
                      <h5>{{ meditation.title }}</h5>
                      <div v-html="meditation.content" />
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3 v-if="error">
      {{ error }}
    </h3>
  </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import {
    mapState, mapActions, vuex, mapGetters
} from 'vuex';
import MeditationBlock from '../../components/Meditations/MeditationBlock.vue';

const data = 'Meditations';

export default {
    // components: {
    //     MB: MeditationBlock
    // },
    data() {
        return {
            title: 'Meditations',
            namespace: 'Meditations'
        };
    },
    computed: {
        ...mapState({
            meditations: (state) => state.Meditations.meditations,
            error: (state) => state.Meditations.error,
        }),
        ...mapGetters({
            abbreviatedMeditationContent: 'Meditations/abbreviatedMeditationContent'
        })
    },
    methods: {
        // i dont know what this is, but russell had it
        getIdFromIndex(index) {
            return this.meditations[index].id;
        },
        getMeditations() {
            this.$store.dispatch(`${this.namespace}/getMeditations`);
        },
        show(index) {
            this.$router.push({ name: 'MeditationShow', params: { id: this.getIdFromIndex(index) } });
        }
    },
    created() {
        this.getMeditations();
        this.$store.commit('Meditations/setError', '');
    },
    beforeDestroy() {
        // todo destroy the state.
    }
};
</script>

<style scoped>
  #icons-wrapper ul li {
    height: 150px;
  }

  .demo-icons ul li:hover {
    cursor: pointer;
  }

  #icons-wrapper h5 {
    height: 60px;
  }
</style>
